import React, { SVGProps } from 'react';

/**
 * Ícone do módulo Interoperabilidade (MV2-1712).
 *
 * Duas setas em sentidos opostos: é a leitura do contrato de visualização —
 * uma seta quando só um lado exibe, as duas quando é bidirecional.
 */
const InteroperabilityIcon = ({
  className,
  fill = '#fff',
  width = 15,
  height = 15,
  style,
}: SVGProps<SVGSVGElement>) => (
  <span className={className} style={style}>
    <svg width={width} height={height} viewBox="0 0 15 15" fill="none">
      <path
        d="M1.5 4.5H11.25L8.75 2"
        stroke={fill as string}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 10.5H3.75L6.25 13"
        stroke={fill as string}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export default InteroperabilityIcon;
